<template>
<!--    {{selectorConfig.value}}-->
    <el-select
        ref="lotsBasicDataSelct"
        :class="{ 'basic-select-reverse': dropDownVisible , 'lots-basic-select-for-lazy':true } "
        v-model="selectorConfig.value"
        :value-key="config.valueKey"
        :loading="selectorConfig.loading"
        :disabled="disabled"
        filterable
        remote
        collapse-tags
        reserve-keyword
        :clearable="config.clearable"
        :placeholder="config.title"
        :remote-method="remoteMethod"
        :multiple="config.multiple"
        :no-data-text="$translate('lotsUI.no_matching_options', { defaultText: '无匹配选项' })"
        @focus="onFocus"
        @change="change"
        v-loadmore:[lotsBasicDataClass]="loadMore"
        :popper-class="lotsBasicDataClass"
        @visible-change="visibleChange"
    >
        <el-option
            class="lots-basic-select-for-search-option"
            v-for="(item, index) in selectorConfig.options"
            :key="index + item.value"
            :label="item.label"
            :value="item.value"
        >
            <span style="float: left">{{ item.label }}</span>
            <span
                v-show="config.showValue"
                class="option-right"
            >{{ config.defineShowKey ? item.defineShowValue : item.value }}</span>
        </el-option>
        <div class="lots-basic-select-loading-info">
            <div v-show="lazyLoaing && !isNoMore" class="load-status" >
                <i class="el-icon-loading" style="font-size: 16px"></i>
                <span style="font-size: 12px;">&nbsp;{{$translate('lotsUI.loading',{defaultText:'加载中'})}}...</span>
            </div>
            <div v-show="isNoMore" class="load-status">
                <span style="font-size: 12px;">&nbsp;{{$translate('lotsUI.no_more',{defaultText:'没有更多'})}}</span>
            </div>
            <i  class="load-status el-icon-more" v-show="!lazyLoaing && !isNoMore"></i>
        </div>
    </el-select>
</template>

<script>
import http from '@/utils/http';
import utils from '../../utils/common';
import { I18nMixins } from '@/components/utils/i18n';
const scrollButtomCallback = function (binding, SELECTDOM) {
    return () => {
        const condition = SELECTDOM.scrollHeight - SELECTDOM.scrollTop === SELECTDOM.clientHeight;
        // 判断滚动到底部
        if (condition) {
            // 执行回调方法
            binding.value();
        }
    };
};
const DEFAULT_TIMEOUT = 300;
let scrollCallback = null;
let timer = '';
export default {
    name: 'lotsBasicDataSelector',
    mixins: [I18nMixins],
    directives: {
        loadmore: {
            // 指令的定义
            update(el, binding) {
                const SELECTDOM = document.querySelector(`.${binding.arg} .el-select-dropdown__wrap`);
                // 为对应的ul绑定滚动条滚动事件
                scrollCallback = scrollButtomCallback(binding, SELECTDOM);
                SELECTDOM.addEventListener('scroll', scrollButtomCallback(binding, SELECTDOM));
            },
            componentUpdated(el, binding) {
                const SELECTDOM = document.querySelector(`.${binding.arg} .el-select-dropdown__wrap`);
                SELECTDOM.removeEventListener('scroll', scrollCallback);
            }
        }
    },
    emits: ['update:modelValue', 'change'],
    props: {
        config: {
            type: Object,
            default: () => {
                return {
                    urlConfig: {},
                    title: '',
                    valueKey: '',
                    labelKey: '',
                    defineShowKey: '',
                    searchKey: '',
                    delay: 1000,
                    showValue: false,
                    clearable: false,
                    getAllData: false,
                    multiple: false
                };
            }
        },
        disabled: { // 是否启动组件
            type: Boolean,
            default: false
        },
        modelValue: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    model: {
        prop: 'modelValue',
        event: 'update:modelValue'
    },
    data() {
        return {
            lotsBasicDataSelct: null,
            originList: [],
            selectorConfig: {
                // value: props.config.getAllData ? {} : '',
                value: [// 'LN202106222740', 'LN00068201'
                    // { lineCode: 'LN202106222740', lineName: '乌兰察布市卓资县-包头市石拐区' },
                    // { lineCode: 'LN00068201', lineName: '徐州市鼓楼区-苏州市相城区' }
                ],
                options: [],
                pageNo: 1,
                pageSize: 30,
                loading: false,
                urlConfig: this.config.urlConfig,
                title: this.config.title,
                valueKey: '',
                valueDesKey: '',
                labelKey: '',
                labelDesKey: '',
                defineShowKey: '',
                defineShowDesKey: '',
                searchKey: this.config.searchKey,
                delay: this.config.delay,
                showValue: this.config.showValue,
                clearable: this.config.clearable,
                getAllData: this.config.getAllData,
                multiple: this.config.multiple
            },
            lotsBasicDataClass: `lots-basic-data-class-${utils.uuid()}`,
            checkedItem: [],
            keyword: '',
            dropDownVisible: false, // 显示开关
            isNoMore: false, // 加载中显示
            initConfigFlag: false,
            lazyLoaing: false // 懒加载显示
        };
    },
    watch: {
        modelValue: {
            handler(newValue) {
                if (!this.initConfigFlag) { // 保证第一次进页面初始化最先执行
                    this.initConfigFlag = true;
                    this.initKeyMap();
                }
                this.checkedItem = [];
                if (this.config.multiple) {
                    this.selectorConfig.value = [];
                    newValue.forEach(item => {
                        this.selectorConfig.value.push(item[this.selectorConfig.valueDesKey]);
                        const find = this.selectorConfig.options.find(optionsItem => {
                            return optionsItem.value === item[this.selectorConfig.valueDesKey];
                        });
                        const option = {
                            value: item[this.selectorConfig.valueDesKey],
                            label: item[this.selectorConfig.labelDesKey],
                            defineShowValue: item[this.selectorConfig.defineShowDesKey] || ''
                        };
                        if (!find) {
                            this.selectorConfig.options.push(option);
                        }
                        this.checkedItem.push(option);
                    });
                } else {
                    if (newValue.length > 0) {
                        // 单选取第一个值，其他忽略
                        const valueItem = JSON.parse(JSON.stringify(newValue[0]));
                        this.selectorConfig.value = valueItem[this.selectorConfig.valueDesKey];
                        const find = this.selectorConfig.options.find(optionsItem => {
                            return optionsItem.value === valueItem[this.selectorConfig.valueDesKey];
                        });
                        const option = {
                            value: valueItem[this.selectorConfig.valueDesKey],
                            label: valueItem[this.selectorConfig.labelDesKey],
                            defineShowValue: valueItem[this.selectorConfig.defineShowDesKey] || ''
                        };
                        if (!find) {
                            this.selectorConfig.options.push(option);
                        }
                        this.checkedItem.push(option);
                    } else {
                        this.selectorConfig.value = '';
                    };
                };
            },
            immediate: true
        }
    },
    methods: {
        onFocus() { // ok
            if (!this.selectorConfig.options.length) {
                this.remoteMethod('', false, 0);
            }
        },
        getData(value, requestMethod) { // 获取数据ok
            const data = {
                ...requestMethod === 'post' ? this.selectorConfig.urlConfig.data : this.selectorConfig.urlConfig.params,
                ...{
                    [this.selectorConfig.searchKey || this.selectorConfig.labelKey]: value,
                    pageNo: this.selectorConfig.pageNo,
                    pageSize: this.selectorConfig.pageSize
                }
            };
            if (requestMethod === 'post') {
                this.selectorConfig.urlConfig.data = data;
            } else {
                this.selectorConfig.urlConfig.params = data;
            }
            return http.request(this.selectorConfig.urlConfig);
        },
        remoteMethod(value, lazy = false) { // 远程请求 ok
            if ((value !== this.keyword) || (!lazy)) {
                this.selectorConfig.pageNo = 1;
                this.isNoMore = false;
            }
            this.keyword = value;
            if (this.isNoMore) {
                return;
            }
            if (lazy && !this.lazyLoaing) {
                this.selectorConfig.pageNo = this.selectorConfig.pageNo + 1;
            }
            if (!lazy) {
                this.selectorConfig.loading = true;
            } else {
                this.lazyLoaing = true;
            }
            // 如果是初始加载，则不使用延迟调接口
            let timeout = DEFAULT_TIMEOUT;
            if (!value && !lazy) {
                timeout = 0;
            } else {
                timeout = this.selectorConfig.delay || DEFAULT_TIMEOUT;
            }
            clearTimeout(timer);
            timer = setTimeout(() => {
                const requestMethod = this.selectorConfig.urlConfig.method.toLowerCase() !== 'post' ? 'get' : 'post';
                this.getData(value, requestMethod).then((res) => {
                    if (res && res.code === '0' && res.data) {
                        // 如果返回list长度为0 ，则讲懒加载设置为没有更多，下次滚动不执行接口调用
                        if (res.data.list.length <= 0) {
                            this.isNoMore = true;
                        }
                        this.formatOptions(res.data.list, lazy);
                    } else {
                        this.selectorConfig.options = [];
                    }
                }).finally(() => {
                    this.lazyLoaing = false;
                    this.selectorConfig.loading = false;
                });
            }, timeout);
        },
        loadMore() { // 加载ok
            this.remoteMethod(this.keyword, true);
        },
        // 选择结果后，抛出结果到v-model
        change(data) { // change事件 ok
            const values = Array.isArray(data) ? data : [data];
            const cbData = [];
            this.selectorConfig.options.forEach(item => {
                if (values.includes(item.value)) {
                    const one = {};
                    one[this.selectorConfig.valueDesKey] = item.value;
                    one[this.selectorConfig.labelDesKey] = item.label;
                    if (this.selectorConfig.defineShowDesKey) {
                        one[this.selectorConfig.defineShowDesKey] = item.defineShowValue;
                    }
                    cbData.push(one);
                }
            });
            const originDataList = this.originList.filter(item => {
                if (values.includes(item[this.selectorConfig.valueKey])) {
                    return true;
                }
                return false;
            });
            this.$emit('update:modelValue', cbData);
            this.$emit('change', cbData, originDataList);
        },
        /* visibleChange--下拉框出现/隐藏时触发 val，出现则为 true，隐藏则为 false */
        visibleChange(visible) { // 下拉框ok
            this.dropDownVisible = !!visible;
            if (visible) {
                this.remoteMethod('', false);
            } else {
                document.querySelector(`.${this.lotsBasicDataClass} .el-select-dropdown__wrap`).scrollTop = 0;
                this.selectorConfig.pageNo = 1;
                this.isNoMore = false;
            }
        },
        formatOptions(list, lazy) { // 过滤传参 ok
            const values = [];
            this.checkedItem.forEach(checkedItem => {
                values.push(checkedItem.value); // values.push(checkedItem.value);
            });
            const data = [];
            list.forEach((listItem) => {
                if (!values.includes(listItem[this.selectorConfig.valueKey])) {
                    data.push({
                        value: listItem[this.selectorConfig.valueKey],
                        label: listItem[this.selectorConfig.labelKey],
                        defineShowValue: listItem[this.selectorConfig.defineShowKey] || ''
                    });
                }
            });
            if (lazy) {
                this.selectorConfig.options = [...this.selectorConfig.options, ...data];
                // selectorConfig.options = Object.freeze([...selectorConfig.options, ...data]);
                this.originList = [...this.originList, ...list];
            } else {
                this.checkedItem.forEach(checkedItem => {
                    data.unshift(checkedItem);
                });
                this.selectorConfig.options = data;
                // selectorConfig.options = Object.freeze(data);
                this.originList = JSON.parse(JSON.stringify(list));
            }
        },
        initKeyMap() { // 初始化
            const valueKeyArr = this.config.valueKey.split('#');
            this.selectorConfig.valueKey = valueKeyArr[0];
            this.selectorConfig.valueDesKey = valueKeyArr[1] ? valueKeyArr[1] : valueKeyArr[0];

            const labelKeyArr = this.config.labelKey.split('#');
            this.selectorConfig.labelKey = labelKeyArr[0];
            this.selectorConfig.labelDesKey = labelKeyArr[1] ? labelKeyArr[1] : labelKeyArr[0];

            if (this.config.defineShowKey) {
                const defineShowKeyArr = this.config.defineShowKey.split('#');
                this.selectorConfig.defineShowKey = defineShowKeyArr[0];
                this.selectorConfig.defineShowDesKey = defineShowKeyArr[1] ? defineShowKeyArr[1] : defineShowKeyArr[0];
            }
        }
    }
};
</script>
<style lang="less">

.lots-basic-select-for-lazy {
    >.el-input {
        margin-left: 0 !important;
    }
    .el-select__tags {
        display: flex;
        flex-wrap: nowrap;
        .el-tag {
            display: flex;
            align-items: center;
            &:first-child {
                width: 80%;
            }
            &:not(&:first-child) {
                width: 66%;
                .el-select__tags-text {
                    max-width: 80% !important;
                }
            }
        }
        >input {
            width: 20% !important;
        }
        .el-select__tags-text {
            text-overflow: ellipsis;
            display: inline-block;
            overflow-x: hidden;
            vertical-align: bottom;
        }
    }
}
.lots-basic-select-for-search{
}
.basic-select-reverse{
}
.lots-basic-select-loading-info{
    text-align: center;
    padding-bottom: 40px;
    font-size: 14px;
    color: #bbb;
    .load-status{
        height: 30px; line-height: 40px;
    }
}
.lots-basic-select-for-search-option{
    .option-right{
        float: right;
        color: #8492a6;
        font-size: 12px;
        margin-left:4px
    }
}
</style>
